const ATTR = "modal-overlay";
const CLASS_ACTIVE = "is-active";

export default class ModalOverlay {
    _clickCallbacks = [];
    active = false;
    _instance;

    static instance() {
        if (this._instance) return this._instance;
        return (this._instance = new this());
    }

    constructor(settings) {
        this.onClick = this.onClick.bind(this);
        this.el = document.querySelector(`[${ATTR}]`);
        this.el.addEventListener("click", this.onClick);

        if (settings) {
            if (typeof settings.onClick === "function") {
                this._clickCallbacks.push(settings.onClick);
            }
        }
    }

    onClick() {
        const { _clickCallbacks: cb } = this;
        for (let i = 0; i < cb.length; i++) cb[i]();
    }

    activate() {
        if (this.active) return;
        this.active = true;
        this.el.classList.add(CLASS_ACTIVE);
    }

    deactivate() {
        if (!this.active) return;
        this.active = false;
        this.el.classList.remove(CLASS_ACTIVE);
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/components/modal-overlay.js